import logo from '../assets/images/logo.png';

export const IMAGES = {
  LOGO: logo,
};